import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Supplier, SupplierTotals, SupplierDetail, CreateSupplierDto, UpdateSupplierDto } from '../models/supplier.model';

@Injectable({ providedIn: 'root' })
export class SuppliersService {
  private http = inject(HttpClient);
  private base = `${environment.apiUrl}/Suppliers`;

  getAll(): Observable<Supplier[]> {
    return this.http.get<Supplier[]>(this.base).pipe(catchError(this.handle));
  }

  getActive(): Observable<Supplier[]> {
    return this.http.get<Supplier[]>(`${this.base}/active`).pipe(catchError(this.handle));
  }

  getAllWithTotals(activeOnly?: boolean, search?: string): Observable<SupplierTotals[]> {
    let params = new HttpParams();
    if (activeOnly !== undefined) {
      params = params.set('activeOnly', activeOnly.toString());
    }
    if (search) {
      params = params.set('search', search);
    }
    return this.http.get<SupplierTotals[]>(`${this.base}/totals`, { params }).pipe(catchError(this.handle));
  }

  getById(id: string): Observable<Supplier> {
    return this.http.get<Supplier>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  getDetail(id: string): Observable<SupplierDetail> {
    return this.http.get<SupplierDetail>(`${this.base}/${id}/detail`).pipe(catchError(this.handle));
  }

  create(dto: CreateSupplierDto): Observable<Supplier> {
    return this.http.post<Supplier>(this.base, dto).pipe(catchError(this.handle));
  }

  update(id: string, dto: UpdateSupplierDto): Observable<Supplier> {
    return this.http.put<Supplier>(`${this.base}/${id}`, dto).pipe(catchError(this.handle));
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`).pipe(catchError(this.handle));
  }

  activeCount(): Observable<number> {
    return this.http.get<{ count: number }>(`${this.base}/active-count`).pipe(
      map(res => res.count),
      catchError(this.handle)
    );
  }

  private handle(err: any) {
    return throwError(() => err);
  }
}
